export default {
  title: 'Projets',
  projectManager: 'Gestionnaire de projets',
  myCurrentProjects: 'Mes projets en cours',
  history: 'Historique',
  noCurrentProjects: 'Aucun projet en cours',
  errorLoadingProjects: 'Erreur lors du chargement des projets',
  freelancerProjectHistory: 'Historique de pige',
  projectInformation: 'Informations du projet',
  projectName: 'Nom du projet',
  priceRange: 'Budget',
  dueDate: "Date d'échéance",
  startDate: 'Date de commencement',
  location: 'Emplacement',
  team: 'Équipe',
  jobOfferDescription: 'Description du projet',
  noDescriptionProvided: 'Aucune description fournie.',
  mySubmission: 'Ma soumission',
  viewAcceptedSubmission: 'Voir ma soumission acceptée',
  viewSubmission: 'Voir la soumission',
  yourAlliances: 'Vos Alliances',
  offer: 'Offre',
  serviceProvider: 'Fournisseur de service',
  myJobOffer: 'Mon projet',
  viewMyJobOffer: 'Voir mon projet',
  biddingSubmissions: 'Pigiste soumissionnaire',
  projectStatus: 'Statut du projet',
  inProgress: 'En cours',
  completed: 'Complété',
  cancelled: 'Annulé',
  changeStatus: 'Changer le statut',
  statusChangeConfirmation: 'Statut du projet',
  statusChangeMessage: 'Vous souhaitez modifier le statut du projet pour',
  projectStatusChanged: 'Le statut du projet a été modifié.',
  statusChangeNotification: 'Tous les participants du projet seront notifiés.',
  cancelAndReturn: 'Retour au Gestionnaire de projets',
  confirm: 'Confirmer',
  grandTotal: 'Grand total',
  description: 'Description',
  status: 'Statut',
  date: 'Date',
  alliances: 'Alliances',
  submission: 'Soumission',
  actions: 'Actions',
  evaluate: 'Évaluer',
  withClient: 'Avec {{name}}',
  publicationDate: 'Date de publication',
  genericErrorUpdatingStatus:
    'Une erreur inconnue est survenue lors de la modification du statut du projet. Veuillez réessayer ou contacter le support.',
  noPastProjects: 'Aucun projet existant',
  loadMore: 'Charger plus de résultats',
  originalJobOffer: "Offre d'emploi d'origine",
  projectDescription: 'Descriptif du projet',
  requestedProjectDeadline: 'Échéance du projet',
  requestedStartDate: 'Date de début',
  serviceType: 'Types de services requis',
  viewJobOffer: "Visualiser une offre d'emploi",
  onSite: 'Travail en présentiel',
  budget: 'Budget',
  languages: 'Langue(s) parlée(s)',
  close: 'Fermer',
} as const;
